import { type Writable, writable } from 'svelte/store';

interface HelpFeedbackData {
  slug: string;
  isHelpful: boolean;
}

const helpFeedbackData: Writable<HelpFeedbackData | null> = writable(null);

export default helpFeedbackData;
